import { useAuth } from '../../hooks/useAuth'
import { useNavigate } from 'react-router-dom'
import { useAdminTheme } from '../../hooks/useAdminTheme'

export function AdminSettingsPage() {
  const { user, logout } = useAuth()
  // ADMIN-ONLY theme (bns-admin-theme). Never touches the customer theme.
  const { adminTheme: theme, setAdminTheme: setTheme } = useAdminTheme()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/admin/login')
  }

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-900">Pengaturan</h1>
        <p className="text-slate-500 mt-1">Kelola pengaturan toko dan akun admin</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <div className="card">
            <div className="p-4 border-b border-slate-200">
              <h2 className="text-lg font-semibold text-slate-900">Informasi Toko</h2>
            </div>
            <div className="p-6 space-y-4">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-blue-100 flex items-center justify-center">
                  <svg className="w-6 h-6 text-blue-600" viewBox="0 0 32 32" fill="none" aria-hidden="true">
                    <rect width="32" height="32" rx="8" fill="currentColor" />
                    <path d="M8 12h16M8 16h12M8 20h8" stroke="white" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-slate-900">CV Berkah Nusa Sejati</h3>
                  <p className="text-sm text-slate-500">Warung Grosir Otomatis</p>
                </div>
              </div>
            </div>
          </div>

          <div className="card mt-6">
            <div className="p-4 border-b border-slate-200">
              <h2 className="text-lg font-semibold text-slate-900">Akun Admin</h2>
            </div>
            <div className="p-6 space-y-4">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center">
                  <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <div>
                  <p className="font-medium text-slate-900">{user?.username || 'Admin'}</p>
                  <p className="text-sm text-slate-500">Administrator</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="card">
            <div className="p-4 border-b border-slate-200">
              <h2 className="text-lg font-semibold text-slate-900">Tampilan</h2>
            </div>
            <div className="p-4 space-y-2">
              <p className="text-sm text-slate-500">Pilih tema aplikasi. Pilihan tersimpan di perangkat ini.</p>
              <div className="flex items-center gap-2" role="radiogroup" aria-label="Pilih tema">
                <button
                  type="button"
                  role="radio"
                  aria-checked={theme === 'light'}
                  onClick={() => setTheme('light')}
                  className={`btn-secondary text-sm${theme === 'light' ? ' border-blue-600' : ''}`}
                >
                  Terang
                </button>
                <button
                  type="button"
                  role="radio"
                  aria-checked={theme === 'dark'}
                  onClick={() => setTheme('dark')}
                  className={`btn-secondary text-sm${theme === 'dark' ? ' border-blue-600' : ''}`}
                >
                  Gelap
                </button>
              </div>
            </div>
          </div>

          <div className="card mt-6">
            <div className="p-4 border-b border-slate-200">
              <h2 className="text-lg font-semibold text-slate-900">Aksi</h2>
            </div>
            <div className="p-4 space-y-2">
              <button onClick={handleLogout} className="btn-danger w-full flex items-center justify-center gap-2">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
                Logout
              </button>
            </div>
          </div>

          <div className="card mt-6">
            <div className="p-4 border-b border-slate-200">
              <h2 className="text-lg font-semibold text-slate-900">Sistem</h2>
            </div>
            <div className="p-4 space-y-3">
              <div className="flex items-center justify-between text-sm">
                <span className="text-slate-600">Versi</span>
                <span className="font-mono text-slate-900">1.0.0</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-slate-600">Database</span>
                <span className="font-mono text-slate-900">SQLite</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-slate-600">Environment</span>
                <span className="badge badge-warning">Development</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}